import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — scrolls to top of the page on every route change,
 * OR scrolls to the target element if the URL contains a #hash.
 *
 * Works with both native and Lenis-managed smooth scroll.
 */
export function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            // Wait a tick for the target page to render, then scroll to the anchor.
            const targetId = hash.replace("#", "");
            const scrollToTarget = () => {
                const el = document.getElementById(targetId);
                if (!el) return false;
                const y = el.getBoundingClientRect().top + window.scrollY - 80; // offset for sticky nav
                try {
                    if (window.__lenis) {
                        window.__lenis.scrollTo(y, { duration: 0.6 });
                    } else {
                        window.scrollTo({ top: y, behavior: "smooth" });
                    }
                } catch {
                    window.scrollTo(0, y);
                }
                return true;
            };
            // Try immediately, then a few retries as content loads
            if (!scrollToTarget()) {
                let tries = 0;
                const iv = setInterval(() => {
                    tries += 1;
                    if (scrollToTarget() || tries > 20) clearInterval(iv);
                }, 60);
            }
            return;
        }
        // No hash — jump to top
        try {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        } catch {
            window.scrollTo(0, 0);
        }
        try {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        } catch {}
        try {
            if (typeof window !== "undefined" && window.__lenis) {
                window.__lenis.scrollTo(0, { immediate: true, force: true });
            }
        } catch {}
    }, [pathname, hash]);
    return null;
}
